export const PROMPT_TITLE_REQUIRED = 'Prompt Title is required';
export const PROMPT_TEXT_REQUIRED = 'Prompt Text is required';
export const PROMPT_IS_MUST_BE = 'Must be either "Yes" or "No"';
export const PROMPT_IS_DEFAULT = 'Is Default Option is required';
